import { graphql } from 'src/graphql';

export const CreateMeeting = graphql(`
  mutation createAskableVideoMeeting($name: String!) {
    createAskableVideoMeeting(input: { name: $name }) {
      _id
      code
      name
    }
  }
`);
